import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const propertyPanelDefaultVariants = {
  "variant": "plain"
}
const propertyPanelCompoundVariants = []

const propertyPanelSlotNames = [
  [
    "root",
    "propertyPanel__root"
  ],
  [
    "section",
    "propertyPanel__section"
  ],
  [
    "sectionHeader",
    "propertyPanel__sectionHeader"
  ],
  [
    "sectionTitle",
    "propertyPanel__sectionTitle"
  ],
  [
    "sectionActions",
    "propertyPanel__sectionActions"
  ],
  [
    "sectionContent",
    "propertyPanel__sectionContent"
  ],
  [
    "item",
    "propertyPanel__item"
  ],
  [
    "itemLabel",
    "propertyPanel__itemLabel"
  ],
  [
    "itemContent",
    "propertyPanel__itemContent"
  ],
  [
    "emptyHint",
    "propertyPanel__emptyHint"
  ],
  [
    "row",
    "propertyPanel__row"
  ],
  [
    "rowIcon",
    "propertyPanel__rowIcon"
  ],
  [
    "rowBody",
    "propertyPanel__rowBody"
  ],
  [
    "rowTitle",
    "propertyPanel__rowTitle"
  ],
  [
    "rowCaption",
    "propertyPanel__rowCaption"
  ],
  [
    "rowMeta",
    "propertyPanel__rowMeta"
  ],
  [
    "header",
    "propertyPanel__header"
  ],
  [
    "headerBar",
    "propertyPanel__headerBar"
  ],
  [
    "headerTitle",
    "propertyPanel__headerTitle"
  ],
  [
    "headerCaption",
    "propertyPanel__headerCaption"
  ]
]
const propertyPanelSlotFns = /* @__PURE__ */ propertyPanelSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, propertyPanelDefaultVariants, getSlotCompoundVariant(propertyPanelCompoundVariants, slotName))])

const propertyPanelFn = memo((props = {}) => {
  return Object.fromEntries(propertyPanelSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const propertyPanelVariantKeys = [
  "variant",
  "selected"
]
const getVariantProps = (variants) => ({ ...propertyPanelDefaultVariants, ...compact(variants) })

export const propertyPanel = /* @__PURE__ */ Object.assign(propertyPanelFn, {
  __recipe__: false,
  __name__: 'propertyPanel',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: propertyPanelVariantKeys,
  variantMap: {
  "variant": [
    "plain",
    "card"
  ],
  "selected": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, propertyPanelVariantKeys)
  },
  getVariantProps
})